const Fields = Object.freeze({
    RECEIPT_NUMBER: "receiptNumber",
    INVOICE_ID: "invoiceId",
    SERIAL_NUMBER: "serialNumber",
    SIMPLIFIED_INVOICE_NUMBER: "simplifiedInvoiceNumber",
    PURCHASE_ID: "purchaseId",
    DATE: "date",
    FLIGHT_NUMBER: "flightNumber",
    TRAIN_NUMBER: "trainNumber",
    ISSUED_BY: "issuedBy",
    NIF: "nif",
    ADDRESS: "address",
    INVOICE_DATE: "invoiceDate",
    INVOICE_NUMBER: "invoiceNumber",
    GENERATED_ON_FOOTER: "generatedOnFooter",
    MOBILE_PAYMENT_FAQ: "mobilePaymentFaq",
    CARD_LABEL: "cardLabel",
    MAESTRO_LABEL: "maestroLabel",
    CARD_MOBILE_LABEL: "cardMobileLabel",
    CASH_LABEL: "cashLabel"
});

module.exports = { Fields };